import { compose, withHandlers } from 'coact/recompose'

import View from './SeriesList.jsx'

const SeriesList = compose(
  withHandlers({
    chooseSeries:
      ({ setCurSeries, setHideEmpty, getStocks }) =>
      series => {
        setCurSeries(series.key)
        getStocks({ series: series.series })
        setHideEmpty(series.hideEmpty)
      },
  }),
)(View)

SeriesList.displayName = 'SeriesList'

export default SeriesList
